import { render, staticRenderFns } from "./FileField.vue?vue&type=template&id=3edfb298&"
import script from "./FileField.vue?vue&type=script&lang=js&"
export * from "./FileField.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports